<table class="table table-hover table-striped">
  <thead>
    <tr>
      <th (click)="sortBy('name')" scope="col" class="cursor-pointer">
        {{ 'label.name' | translate }}
        <span *ngIf="sortColumn === 'name'">
          <i class="bi" [class]="sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill'"></i>
        </span>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let row of items"
      [routerLink]="[row.id]"
      class="clickable cursor-pointer"
    >
      <td>{{ row.name }}</td>
    </tr>
  </tbody>
</table>
